import { render, staticRenderFns } from "./TransactionsStatusFormatter.vue?vue&type=template&id=c6bee540&"
import script from "./TransactionsStatusFormatter.vue?vue&type=script&lang=js&"
export * from "./TransactionsStatusFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports